import AutoCompleteSelect from './AutoCompleteSelect';
export default AutoCompleteSelect;
